module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [(_vm.profileimg !== '') ? _c('img', {
    staticClass: "img-employee user-image",
    attrs: {
      "src": _vm.profileimg
    }
  }) : _vm._e(), _vm._v(" "), (_vm.profileimg === '') ? _c('img', {
    staticClass: "img-employee user-image",
    attrs: {
      "src": require("static/images/employee/no_image.png")
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v("\n      " + _vm._s(_vm.currentUser.username[_vm.nowLang]) + "\n    ")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header"
  }, [(_vm.$router.match('profileimg').name !== '404') ? [_c('router-link', {
    staticClass: "profileimg",
    attrs: {
      "to": {
        name: 'profileimg'
      }
    }
  }, [(_vm.profileimg !== '') ? _c('img', {
    staticClass: "img-employee img-circle",
    attrs: {
      "src": _vm.profileimg
    }
  }) : _vm._e(), _vm._v(" "), (_vm.profileimg === '') ? _c('img', {
    staticClass: "img-employee img-circle",
    attrs: {
      "src": require("static/images/employee/no_image.png")
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "profile-edit img-circle"
  }, [_c('i', {
    staticClass: "fa fa-camera"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Change")])])])] : [(_vm.profileimg !== '') ? _c('img', {
    staticClass: "img-employee img-circle",
    attrs: {
      "src": _vm.profileimg
    }
  }) : _vm._e(), _vm._v(" "), (_vm.profileimg === '') ? _c('img', {
    staticClass: "img-employee img-circle",
    attrs: {
      "src": require("static/images/employee/no_image.png")
    }
  }) : _vm._e()], _vm._v(" "), _c('p', [_vm._v("\n        " + _vm._s(_vm.currentUser.p_coduser) + " : " + _vm._s(_vm.currentUser.username[_vm.nowLang]) + "\n        "), _c('small', [_vm._v(_vm._s(_vm.currentUser.company[_vm.nowLang]))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.currentUser.position[_vm.nowLang]))])])], 2), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [(_vm.version >= '2.0.0') ? [_c('div', {
    staticClass: "pull-left"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "to": {
        name: 'hres31x'
      }
    }
  }, [_vm._v("\n            Profile\n          ")])], 1)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    on: {
      "click": function($event) {
        _vm.postLogout()
      }
    }
  }, [_vm._v("Logout")])])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-483afff7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dash/headers/HeaderUser.vue
// module id = 3730
// module chunks = 1